module.exports = __webpack_public_path__ + "img/cao_logo.dcaf5b79.png";